module.exports = __webpack_public_path__ + "img/affiliate-2.44bcbaa0.png";